module.exports = __webpack_public_path__ + "img/img (45).37f955b3.png";